var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA11YmenuArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64645 11.6464C3.45118 11.8417 3.45118 12.1583 3.64645 12.3536C3.84171 12.5488 4.15829 12.5488 4.35355 12.3536L3.64645 11.6464ZM12.5 4C12.5 3.72386 12.2761 3.5 12 3.5L7.5 3.5C7.22386 3.5 7 3.72386 7 4C7 4.27614 7.22386 4.5 7.5 4.5L11.5 4.5L11.5 8.5C11.5 8.77614 11.7239 9 12 9C12.2761 9 12.5 8.77614 12.5 8.5L12.5 4ZM4.35355 12.3536L12.3536 4.35355L11.6464 3.64645L3.64645 11.6464L4.35355 12.3536Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA11YmenuArrow);
export default __webpack_public_path__ + "static/media/a11ymenu_arrow.6163865e1128f2c1ef0526cdfad96378.svg";
export { ForwardRef as ReactComponent };